import Tabs, { Tab } from "@albertsons/uds/molecule/Tabs";
import LpnandSatTab from "../../common/tab/InterfacesTab/LpnandSatTab";
import "./L2Interfaces.css";
import LpnandSatHistoryTab from "../../common/tab/InterfacesHistory/LpnandSatHistoryTab";
import Header from "@albertsons/uds/molecule/Header";
import React from "react";

const LpnandSat = () => {
  return (
    <div>
      <Header title="LPN and Satellite Inventory MA NON PROD DATA Refresh"></Header>

      <div className="col-12 margin-left">
        <Tabs variant="light">
          <Tab>
            <Tab.Header>LPN and Satellite Inventory Data Load</Tab.Header>
            <Tab.Content>
              <LpnandSatTab />
            </Tab.Content>
          </Tab>
          <Tab>
            <Tab.Header>LPN and Satellite Inventory History</Tab.Header>
            <Tab.Content>
              <LpnandSatHistoryTab />
            </Tab.Content>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default LpnandSat;
